import "./App.scss";

import { BrowserRouter, Switch, Route } from "react-router-dom";

import Home from "./views/Home";
import StartDossier from "./views/StartDossier";
import LienDossier from "./views/LienDossier";
import DossierExercice from "./views/DossierExercice";
import DossierAdresse from "./views/DossierAdresse";
import DossierVotreBien from "./views/DossierVotreBien";
import DossierVotreBienForm from "./views/DossierVotreBienForm";
import DossierVotreBienForm2 from "./views/DossierVotreBienForm2";
import DossierVotreActivite from "./views/DossierVotreActivite";
import DossierVotreLiasseFiscale from "./views/DossierVotreLiasseFiscale";

function App() {
  return (
    <BrowserRouter basename="/applet/lmnp">
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/continuer/:id" component={LienDossier} />
        <Route exact path="/dossier" component={StartDossier} />
        <Route exact path="/nouveau-dossier" component={DossierExercice} />
        <Route path="/dossier/adresse" component={DossierAdresse} />
        <Route path="/dossier/votre-bien" component={DossierVotreBien} />


        <Route
          path="/dossier/votre-bien-form"
          component={DossierVotreBienForm}
        />
        <Route
          path="/dossier/votre-bien-form2"
          component={DossierVotreBienForm2}
        />
        <Route
          path="/dossier/votre-activite"
          component={DossierVotreActivite}
        />
        <Route
          path="/dossier/votre-liasse-fiscale"
          component={DossierVotreLiasseFiscale}
        />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
